var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"paypal"},[_c('Spinner',{attrs:{"size":8,"thickness":3}}),_c('PaypalButtons',{staticClass:"buttons",style:(_vm.style),attrs:{"env":_vm.env,"createOrder":_vm.order,"onApprove":_vm.approve,"onError":_vm.error}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }